import React from 'react';
import { AnimateSharedLayout } from 'framer-motion';
import ChatTab from './ChatTab';

export default function ChatTabMenu({ tabs }) {
  return (
    <AnimateSharedLayout>
      <ul className={`chat_tabs`}>
        {tabs.map((action, i) => {
          return <ChatTab tab={action} i={i} key={i} />;
        })}
      </ul>
    </AnimateSharedLayout>
  );
}
